import { render, staticRenderFns } from "./distributorBinding.vue?vue&type=template&id=65c4d551&scoped=true"
import script from "./distributorBinding.vue?vue&type=script&lang=js"
export * from "./distributorBinding.vue?vue&type=script&lang=js"
import style0 from "./distributorBinding.vue?vue&type=style&index=0&id=65c4d551&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4d551",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c4d551')) {
      api.createRecord('65c4d551', component.options)
    } else {
      api.reload('65c4d551', component.options)
    }
    module.hot.accept("./distributorBinding.vue?vue&type=template&id=65c4d551&scoped=true", function () {
      api.rerender('65c4d551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/product/distributorBinding.vue"
export default component.exports